import { Dialog } from '@mui/material';
import { observer } from 'mobx-react-lite';
import NotificationTabs from 'organisms/Notification/NotificationTabs';
import React from 'react';
import { useStore } from 'stores/store';
import { useMobileDetect } from 'utils/hooks/useMobileDetect';

const NotificationDialog = ({ className }: { className?: string }) => {
  const store = useStore();
  const { isMobile } = useMobileDetect();

  const onClose = async () => {
    store.UIStore.setNotificationsActive(false);
  };

  return (
    <Dialog
      className={className}
      fullScreen
      open={isMobile && store.UIStore.isNotificationsActive}
      onClose={onClose}
      TransitionProps={{ timeout: { enter: 0, exit: 0 } }}
    >
      <NotificationTabs onClose={onClose} />
    </Dialog>
  );
};

export default observer(NotificationDialog);
